import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withSuperJSONPage as _withSuperJSONPage } from "babel-plugin-superjson-next/tools";
import { Layout } from "@components/Layout/Layout";
import { classNames } from "@utils/classNames";
import Link from "next/link";
function Home(param) {
    let { jobPosts , totalHits , nextCursor , jobPostSearchParams  } = param;
    return /*#__PURE__*/ _jsxs(Layout, {
        pageTitle: "Sponsors",
        hasSearch: true,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: classNames("px-4 text-center"),
                children: [
                    /*#__PURE__*/ _jsx("h1", {
                        className: "text-5xl tracking-tight font-black text-black sm:text-6xl md:text-7xl",
                        children: "Sponsors"
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        className: "mt-6 text-xl tracking-tight font-semiboldX text-black sm:mt-8 sm:text-3xl md:mt-10 md:text-xl",
                        children: [
                            "We are open for our first sponsorships. ",
                            /*#__PURE__*/ _jsx("br", {}),
                            "Help support the JavaScript community by becoming a sponsor. ",
                            /*#__PURE__*/ _jsx("br", {}),
                            " ",
                            /*#__PURE__*/ _jsx("span", {
                                className: "text-lg",
                                children: "\uD83D\uDC69‍\uD83D\uDCBB\uD83D\uDC69\uD83C\uDFFB‍\uD83D\uDCBB\uD83D\uDC69\uD83C\uDFFC‍\uD83D\uDCBB\uD83D\uDC69\uD83C\uDFFD‍\uD83D\uDCBB\uD83D\uDC69\uD83C\uDFFE‍\uD83D\uDCBB\uD83D\uDC69\uD83C\uDFFF‍\uD83D\uDCBB\uD83E\uDDD1‍\uD83D\uDCBB\uD83E\uDDD1\uD83C\uDFFB‍\uD83D\uDCBB\uD83E\uDDD1\uD83C\uDFFC‍\uD83D\uDCBB\uD83E\uDDD1\uD83C\uDFFD‍\uD83D\uDCBB\uD83E\uDDD1\uD83C\uDFFE‍\uD83D\uDCBB\uD83E\uDDD1\uD83C\uDFFF‍\uD83D\uDCBB\uD83D\uDC68‍\uD83D\uDCBB\uD83D\uDC68\uD83C\uDFFB‍\uD83D\uDCBB\uD83D\uDC68\uD83C\uDFFC‍\uD83D\uDCBB\uD83D\uDC68\uD83C\uDFFD‍\uD83D\uDCBB\uD83D\uDC68\uD83C\uDFFE‍\uD83D\uDCBB\uD83D\uDC68\uD83C\uDFFF‍\uD83D\uDCBB"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "max-w-4xl m-auto",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "mt-20 text-center",
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: "p-8 font-bold border bg-gray-100 text-blue-600 rounded-lg hover:bg-gray-200",
                        href: "https://github.com/sponsors/JobsinJS",
                        children: "Be the first sponsor!"
                    })
                })
            })
        ]
    });
}
export var __N_SSP = true;
export default _withSuperJSONPage(Home);
